<template>
  <div class="dateRange">
    <span
      v-for="item in dateRange"
      :class="currentDateRange == item.date ? 'active' : 'unactive'"
      :key="item.date"
      @click="changeRange(item.date)"
      >{{ item.name }}</span
    >
  </div>
</template>

<script>
export default {
  name: 'card-M',
  props: {},
  data() {
    return {
      currentDateRange: 'week',
      dateRange: [
        // {
        //   date: 'week',
        //   name: '本周'
        // },
        { date: 'month', name: '本月' },
        { date: 'year', name: '本年' }
      ]
    };
  },
  methods: {
    changeRange(data) {
      this.currentDateRange = data;
      this.$emit('changeRange', data);
    }
  }
};
</script>

<style scoped  scoped lang="scss">
.dateRange {
  width: 100%;
  height: 25%;
  display: flex;
  justify-content: space-evenly;
  span {
    cursor: pointer;
    display: flex;
    font-size: 0.875rem;
    width: 69px;
    height: 40px;
    align-items: center;
    justify-content: center;
    color: rgb(128, 128, 128);
    font-family: Noto Sans SC;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -1px;
    text-align: left;
    &:hover {
      color: rgba(38, 120, 255, 0.9);
      border-bottom: 3px solid rgba(38, 120, 255, 0.9);
    }
  }
  .active {
    color: rgba(38, 120, 255, 0.9);
    border-bottom: 3px solid rgba(38, 120, 255, 0.9);
  }
}
</style>
